var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},_vm._l((_vm.max),function(index){return _c('v-icon',{key:index,attrs:{"color":_vm.getColor(index),"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.getIcon(index))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }